import { render, staticRenderFns } from "./DialogUploadResourceCollections.vue?vue&type=template&id=f0cd0fe8&scoped=true"
import script from "./DialogUploadResourceCollections.vue?vue&type=script&lang=js"
export * from "./DialogUploadResourceCollections.vue?vue&type=script&lang=js"
import style0 from "./DialogUploadResourceCollections.vue?vue&type=style&index=0&id=f0cd0fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cd0fe8",
  null
  
)

export default component.exports